import { createContext } from 'react'
import * as Config from '../config'
import * as GQL from '../gql'

interface SurveysContextType {
  evaluateTrigger: (trigger: Config.Trigger) => Promise<void>
  submitSurvey: (surveyResults: GQL.SurveyResponse) => Promise<void>
}

export const SurveysContext = createContext<SurveysContextType>({
  evaluateTrigger: async () => {},
  submitSurvey: async () => {},
})
